export default __webpack_public_path__ + "static/media/Varun.78f15d74.jpg";